import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'vertical-timeline',
  templateUrl: './vertical-timeline.component.html',
  styleUrls: ['./vertical-timeline.component.scss']
})
export class VerticalTimelineComponent implements OnInit {
  timelines;
  timelineYears = [];
  @Input()
  set PropertyTimelines(timelines) {
    this.timelines = timelines.reverse();

    this.timelines.map(timeline => {
      timeline.year = this.getYear(timeline);
      if (!this.timelineYears.includes(timeline.year)) {
        timeline.showYear = true;
        this.timelineYears.push(timeline.year);
      } else {
        timeline.showYear = false;
      }
    });
    this.timelines = this.timelines.reverse();

    if (this.timelines.length > 0 && !this.timelines[0].showYear) {
      this.timelines[0].year = `...`;
      this.timelines[0].showYear = true;
    }
  }
  constructor() {}

  ngOnInit() {
    this.timelineYears = [];
  }

  getYear(timeline) {
    const timelineDate = new Date(timeline.eventDate);
    const year = timelineDate.getUTCFullYear();
    return year;
  }
}
